export const lowConcernLevelTooltip = 'ObservationPage.LowContinueReport';

export const mediumConcernLevelTooltip = 'ObservationPage.MediumUseCautionReport';

export const highConcernLevelTooltip = 'ObservationPage.HighStopWorkReport';